import React from 'react';
import { Button, Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Banner from '../components/Banner';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import logo_sateco from '../assets/images/logo_sateco_bis.png';
import logo_agriclim from '../assets/images/logo-agriclim.png';
import logo_optimize from '../assets/images/logo-optimize.png';
import '../styles/Home.css';

const Home = () => {
  return (
    <>
      <Banner />
      
      {/* Section Présentation GUIRETTE */}
      <section className="py-5 bg-gradient-success text-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <Badge bg="light" text="dark" className="mb-4 px-3 py-2 rounded-pill fw-bold">
                🚀 LA RÉFÉRENCE AGRICOLE 4.0
              </Badge>
              <h2 className="display-5 fw-bold mb-4">
                GUIRETTE : <span className="text-warning">Vos Alliés Technologiques</span> qui <span className="text-warning">Multiplient vos Bénéfices</span>
              </h2>
              <p className="lead mb-4 fs-5">
                Startup marseillaise qui révolutionne l'agriculture par le digital. 
                Nous combinons cartographie satellitaire, prédiction climatique sur 20 ans et IA agronomique pour
                <strong> maximiser votre rentabilité, anticiper les aléas et réduire vos pertes</strong>.
              </p>
              <div className="impact-stats">
                <Row className="g-4 justify-content-center">
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">+42%</div>
                      <small>Rendement moyen</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">-65%</div>
                      <small>Réduction des pertes</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">20 ans</div>
                      <small>Données climatiques</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">95%</div>
                      <small>Précision prédictive</small>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section Solutions : SaTeCO+ / AgriClim-Decision / OptimizeAgro */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <Badge bg="success" className="mb-3 px-4 py-2 rounded-pill fs-6">
              🌟 NOS SOLUTIONS INTELLIGENTES
            </Badge>
            <h2 className="display-5 fw-bold text-dark">
              La puissance de l'IA au service de <span className="text-success">votre exploitation</span>
            </h2>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
              Des outils connectés, précis et actionnables pour piloter vos cultures, anticiper le climat et optimiser chaque décision.
            </p>
          </div>

          <Row className="g-4">
            {/* Carte SaTeCO+ */}
            <Col md={6} lg={4}>
              <Card className="h-100 border-0 shadow-sm hover-card">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-3">
                    <img src={logo_sateco} alt="SaTeCO+" height="60" className="me-3" />
                    <Badge bg="success" className="rounded-pill">⭐ Solution phare</Badge>
                  </div>
                  <h3 className="h2 fw-bold text-success mb-2">SaTeCO+</h3>
                  <p className="text-muted mb-3">L'œil satellite intelligent pour votre exploitation</p>
                  <p className="mb-3">
                    Analyse satellitaire des sols et surveillance des cultures en temps réel. 
                    Transformez les données brutes en recommandations profitables.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><span className="text-success fw-bold me-2">✓</span> Analyse express en 5-10 min</li>
                    <li className="mb-2"><span className="text-success fw-bold me-2">✓</span> 10 paramètres : pH, NPK, carbone, texture...</li>
                    <li className="mb-2"><span className="text-success fw-bold me-2">✓</span> Cartes de fertilité mensuelles</li>
                    <li className="mb-2"><span className="text-success fw-bold me-2">✓</span> Surveillance continue et alertes</li>
                  </ul>
                  <div className="d-grid gap-2">
                    <Button 
                      variant="success" 
                      className="rounded-pill fw-bold"
                      as={Link}
                      to="/demo"
                    >
                      🎥 Demander une démo
                    </Button>
                    <a 
                      href="https://satecoplus.guirette.net" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-outline-success rounded-pill"
                    >
                      🌐 Accéder à SaTeCO+
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Carte AgriClim-Decision */}
            <Col md={6} lg={4}>
              <Card className="h-100 border-0 shadow-sm hover-card">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-3">
                    <img src={logo_agriclim} alt="AgriClim" height="60" className="me-3" />
                    <Badge bg="info" className="rounded-pill text-dark">🤖 Prédiction IA</Badge>
                  </div>
                  <h3 className="h2 fw-bold text-info mb-2">AgriClim-Decision</h3>
                  <p className="text-muted mb-3">Calendrier de semis intelligent & protection climatique</p>
                  <p className="mb-3">
                    Générez des calendriers de semis personnalisés grâce à un modèle prédictif basé sur 
                    <strong> 20 ans de données climatiques historiques</strong>. Anticipez les aléas et maximisez vos rendements.
                  </p>
                 
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><span className="text-info fw-bold me-2">🌱</span> Basé sur culture, variété, localisation</li>
                    <li className="mb-2"><span className="text-info fw-bold me-2">❄️</span> Anticipez gels tardifs, sécheresses, excès d'eau</li>
                    <li className="mb-2"><span className="text-info fw-bold me-2">📊</span> Modèle prédictif sur 20 ans</li>
                    <li className="mb-2"><span className="text-info fw-bold me-2">📍</span> Précision à la parcelle</li>
                  </ul>
                  <div className="d-grid gap-2">
                    <a 
                      href="https://agriclim.guirette.net" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-info rounded-pill fw-bold text-dark"
                    >
                      🌾 Utiliser AgriClim
                    </a>
                   
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Carte OptimizeAgro */}
            <Col md={12} lg={4}>
              <Card className="h-100 border-0 shadow-sm hover-card">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-3">
                     <img src={logo_optimize} alt="OptimizeAgro" height="60" className="me-3" />
                    <Badge bg="warning" className="rounded-pill text-dark">💡 Décisions actionnables</Badge>
                  </div>
                  <h3 className="h2 fw-bold text-warning mb-2">OptimizeAgro</h3>
                  <p className="text-muted mb-3">IA pour décisions agronomiques précises</p>
                  <p className="mb-3">
                    Combinaison unique de <strong>données météo temps réel, IA et connaissances scientifiques</strong> 
                    pour vous proposer des actions agronomiques concrètes, réduisant les pertes et les coûts.
                  </p>
                 
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><span className="text-warning fw-bold me-2">🎯</span> Plans d'action personnalisés irrigation/fertilisation</li>
                    <li className="mb-2"><span className="text-warning fw-bold me-2">🧪</span> Données scientifiques par culture</li>
                    <li className="mb-2"><span className="text-warning fw-bold me-2">🌡️</span> Météo hyperlocale + prévisions</li>
                    <li className="mb-2"><span className="text-warning fw-bold me-2">📈</span> Réduction des pertes et optimisation des coûts</li>
                  </ul>
                  <div className="d-grid gap-2">
                    <a 
                      href="https://optimize.guirette.net" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-warning rounded-pill fw-bold text-dark"
                    >
                      🚀 Lancer OptimizeAgro
                    </a>
                   
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Message complémentaire sur l'écosystème */}
          <div className="text-center mt-5 pt-3">
            <p className="text-muted fs-5">
              📡 Une suite complète pour <strong>piloter vos cultures, anticiper le climat et agir avec précision</strong> 
              — disponible immédiatement sur abonnement.
            </p>
          </div>
        </Container>
      </section>

      {/* Section preuve sociale rapide */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h3 className="h2 fw-bold mb-4">
                Rejoignez les <span className="text-success">500+ Exploitants</span> qui nous Font Confiance
              </h3>
              <Row className="g-4">
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-success mb-2">95%</div>
                    <small className="text-muted">de satisfaction client</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-primary mb-2">7/7j</div>
                    <small className="text-muted">Support technique</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-success mb-2">24h</div>
                    <small className="text-muted">Délai mise en service</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-primary mb-2">20 ans</div>
                    <small className="text-muted">de données climatiques</small>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <WhyChooseUs />
      <Testimonials />
    </>
  );
};

export default Home;